import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";



const JavaScriptLesson8 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3>Differences between var, let & const</h3>
            <table class="table table-responsive table-bordered">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">var</th>
                <th scope="col">let</th>
                <th scope="col">const</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1</th>
                <td>Can be re-declared</td>
                <td>Cannot be re-declared</td>
                <td>Cannot be re-declared</td>
              </tr>
              <tr>
                <th scope="row">2</th>
                <td>Can be re-assigned</td>
                <td>Can be re-assigned</td>
                <td>Cannot be re-assigned</td>
              </tr>
            </tbody>
          </table>


    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson8